import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';

const ThemeToggleButton = () => {
    // 1. Initialize state for the current theme
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

    // 2. Function to update the theme on the HTML element
    const updateThemeOnHtmlEl = (currTheme) => {
        document.documentElement.setAttribute('data-theme', currTheme);
    };

    // 3. On initial render, set the theme from localStorage
    useEffect(() => {
        updateThemeOnHtmlEl(theme);
    }, [theme]);

    // 4. Toggle theme when button is clicked
    const handleThemeToggle = () => {
        const newTheme = theme === 'dark' ? 'light' : 'dark';
        setTheme(newTheme);
        localStorage.setItem('theme', newTheme);
        updateThemeOnHtmlEl(newTheme);
    };

    return (
        <button
            type="button"
            data-theme-toggle
            aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
            title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
            className="w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center border-0"
            onClick={handleThemeToggle}
        >
            {theme === 'dark' ? (
                <Icon icon="iconoir:sun-light" className="text-primary-light text-xl" />
            ) : (
                <Icon icon="iconoir:half-moon" className="text-primary-light text-xl" />
            )}
        </button>
    );
};

export default ThemeToggleButton;
